var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "larab1tyma"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v1641H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bpzf70sjtb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.674 0C2.437 0 2.78.52 2.78.52V.08h.777v3.478h-.553c-.124 0-.224-.118-.224-.224V3.11s-.341.514-1.107.514C.746 3.624 0 2.877 0 1.82 0 .66.849 0 1.674 0zm.138.711c-.58 0-1.02.468-1.02 1.1 0 .7.51 1.114 1.022 1.114.61 0 1.034-.539 1.034-1.106 0-.51-.356-1.108-1.036-1.108z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fcsbct96oc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.826 0C2.69 0 3.15.688 3.15 1.332V3.56h-.54a.238.238 0 0 1-.238-.238V1.504c0-.357-.218-.79-.724-.79-.546 0-.87.515-.87 1V3.56H.224A.218.218 0 0 1 0 3.335V.08h.778v.43C.954.247 1.298 0 1.826 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5ub2lb5qd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.558 0v5.22h-.553c-.124 0-.224-.119-.224-.225v-.224s-.341.514-1.107.514C.746 5.285 0 4.538 0 3.479c0-1.157.849-1.818 1.674-1.818.763 0 1.107.52 1.107.52V0h.777zM1.812 2.372c-.58 0-1.02.467-1.02 1.1 0 .7.51 1.114 1.022 1.114.61 0 1.034-.54 1.034-1.107 0-.51-.356-1.107-1.036-1.107z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p5a1s9jsqe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.713 0c.143 0 .277.026.277.026V.83S1.823.764 1.621.764c-.546 0-.843.516-.843 1.001V3.52H.224A.218.218 0 0 1 0 3.295V.04h.778v.58A.958.958 0 0 1 1.713 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vkfhkpzayf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.778 0v3.48H.224A.218.218 0 0 1 0 3.254V0h.778z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n88yd111rg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.558 0v5.22h-.553c-.124 0-.224-.119-.224-.225v-.224s-.341.514-1.107.514C.746 5.285 0 4.538 0 3.479c0-1.157.849-1.818 1.674-1.818.763 0 1.107.52 1.107.52V0h.777zM1.812 2.372c-.58 0-1.02.467-1.02 1.1 0 .7.51 1.114 1.022 1.114.61 0 1.034-.54 1.034-1.107 0-.51-.356-1.107-1.036-1.107z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "85cgaf2sth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.514 0a.514.514 0 1 1 0 1.028.514.514 0 0 1 0-1.028z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zfgrv5k8bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.814 0c1.06 0 1.838.825 1.838 1.82 0 .812-.604 1.806-1.84 1.806C.809 3.626 0 2.879 0 1.814 0 .645.95 0 1.814 0zm.003.726c-.551 0-1.04.433-1.04 1.1 0 .657.514 1.086 1.041 1.086.569 0 1.042-.477 1.042-1.096 0-.608-.446-1.09-1.043-1.09z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dchq2l5sbj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.138.201a.399.399 0 0 1 .548-.146c.191.112.259.358.147.55l-1.99 3.447c3.434 1.86 5.757 5.332 6.141 9.397H0c.384-4.065 2.708-7.538 6.138-9.397L4.148.606a.402.402 0 0 1 .147-.551.402.402 0 0 1 .55.146l2.017 3.491a12.293 12.293 0 0 1 5.13-1.094c1.862 0 3.593.392 5.13 1.094zM6.486 8.071a1.006 1.006 0 1 0 0 2.01 1.006 1.006 0 0 0 0-2.01zm11.01 0a1.006 1.006 0 1 0 0 2.01 1.006 1.006 0 0 0 0-2.01z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#larab1tyma)",
    transform: "translate(-478 -752)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bpzf70sjtb)",
    transform: "translate(478 770.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.558v3.624H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fcsbct96oc)",
    transform: "translate(482.415 770.849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.15v3.56H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5ub2lb5qd)",
    transform: "translate(486.158 769.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.558v5.285H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p5a1s9jsqe)",
    transform: "translate(490.573 770.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.99v3.519H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vkfhkpzayf)",
    transform: "translate(497.058 770.929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h.778v3.48H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n88yd111rg)",
    transform: "translate(498.442 769.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.558v5.285H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#85cgaf2sth)",
    transform: "translate(496.927 769.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.028v1.028H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zfgrv5k8bi)",
    transform: "translate(492.8 770.849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.652v3.626H0V0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dchq2l5sbj)",
    transform: "translate(478.014 753.526)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00E17A",
    d: "M0 0h23.984v13.449H0V0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.5044d8d8364f56c364bd1097d920313c.svg";
export { ForwardRef as ReactComponent };